import { createContext } from 'react';

import type { SelectionType, SELECT_ALL_ITEMS } from './types';

export interface TableContextType {
  /**
   * Indicates the bulk selection state of the table.
   * It can be a boolean or the string 'indeterminate'.
   */
  bulkSelectState?: boolean | 'indeterminate';
  /**
   * The number of selected items in the table.
   * This can be a number or the string 'All' (which means that all items are selected).
   */
  selectedItemsCount: typeof SELECT_ALL_ITEMS | number;
  /** Indicates whether the table is in select mode. */
  selectMode: boolean;
  /** The total number of items in the table. */
  itemCount: number;
  /** Indicates whether the table is selectable. */
  selectable?: boolean;
}

export const TableContext = createContext<TableContextType | undefined>(undefined);

export const TableSelectionChangeContext = createContext<
  ((selectionType: SelectionType, selection?: string) => void) | undefined
>(undefined);

export interface TableRowContextType {
  /** Indicates whether the table is selectable. */
  selectable: boolean;
  /** Indicates whether the table is in select mode. */
  selectMode: boolean;
}

export const TableRowContext = createContext<TableRowContextType | undefined>(undefined);
